import { useEffect, useState } from 'react';
import { X, Printer, QrCode } from '../../lib/icons';
import { toast } from 'sonner';
import { lienCompte, qrDataUrl } from '../../lib/portail';
import { publierCompte } from '../../lib/dataProvider';

// QR de solde du tiers : lien permanent protégé par un jeton unique, sans mot de passe.
export const QrSoldeDialog = ({ tiersId, nom, tel, onClose }) => {
  const [lien, setLien] = useState('');
  const [image, setImage] = useState('');

  useEffect(() => {
    let vivant = true;
    (async () => {
      const url = lienCompte(tiersId);
      // Republication de l'instantané pour que le solde flashé soit à jour.
      await publierCompte(tiersId);
      const img = await qrDataUrl(url);
      if (!vivant) return;
      setLien(url);
      setImage(img);
    })();
    return () => { vivant = false; };
  }, [tiersId]);

  const message = `Bonjour ${nom}, consultez votre relevé (factures, avances, reste à payer) chez nous : ${lien}`;

  return (
    <div data-testid="qr-solde-overlay" className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/60 p-4 print:static print:bg-white print:p-0">
      <div className="w-full max-w-md border border-slate-200 bg-white">
        <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3 print:hidden">
          <p className="flex items-center gap-2 font-heading text-sm font-bold text-slate-900">
            <QrCode size={15} /> QR code de solde — {nom}
          </p>
          <button type="button" data-testid="qr-solde-fermer" onClick={onClose} className="border border-slate-300 p-2 text-slate-600 hover:bg-slate-900 hover:text-white">
            <X size={16} />
          </button>
        </div>

        <div className="px-5 py-5 text-center" data-testid="qr-solde-doc">
          <p className="font-heading text-base font-black text-slate-900">{nom}</p>
          <p className="font-data text-[11px] uppercase tracking-[0.1em] text-slate-500">Relevé permanent · lecture seule</p>
          {image ? (
            <img data-testid="qr-solde-image" src={image} alt={`QR solde ${nom}`} className="mx-auto mt-4 h-56 w-56" />
          ) : (
            <p className="py-16 text-xs text-slate-500">Génération du QR code…</p>
          )}
          <p className="mt-3 break-all font-data text-[11px] text-slate-600">{lien}</p>
          <p className="mt-2 text-xs text-slate-500">
            En flashant ce code, le fournisseur voit en temps réel ses factures, les avances versées et son reste à payer exact. Aucun mot de passe : le jeton du lien fait office de clé.
          </p>
        </div>

        <div className="flex flex-wrap gap-2 border-t border-slate-200 px-4 py-3 print:hidden">
          <button
            type="button"
            data-testid="qr-solde-copier"
            disabled={!lien}
            onClick={() => { navigator.clipboard?.writeText(lien); toast.success('Lien copié'); }}
            className="h-10 flex-1 border border-slate-300 text-xs font-bold text-slate-700 hover:bg-slate-100 disabled:opacity-50"
          >
            Copier le lien
          </button>
          <a
            data-testid="qr-solde-whatsapp"
            href={`https://wa.me/${String(tel || '').replace(/\D/g, '')}?text=${encodeURIComponent(message)}`}
            target="_blank"
            rel="noreferrer"
            className="flex h-10 flex-1 items-center justify-center bg-emerald-700 text-xs font-bold text-white hover:bg-emerald-800"
          >
            Envoyer par WhatsApp
          </a>
          <button
            type="button"
            data-testid="qr-solde-imprimer"
            onClick={() => window.print()}
            className="flex h-10 flex-1 items-center justify-center gap-2 bg-slate-900 text-xs font-bold text-white hover:bg-slate-700"
          >
            <Printer size={14} /> Imprimer
          </button>
        </div>
      </div>
    </div>
  );
};
